import { AxiosGlobalFilters } from '../config';
const HomeService = {
  getHomeDashAtividades: ({ token, unidade, empresa, Month, Year, SubGrupoUnidadeId, GrupoUnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/reports/summary/activities',
      params: {
        Month,
        Year,
        SubGrupoUnidadeId,
        GrupoUnidadeId,
      },
      headers: {
        'content-type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
        EmpresaId: empresa,
        UnidadeId: unidade !== undefined ? unidade : '',
      },
    });
  },
  getHomeDashOcorrencias: ({ token, unidade, empresa, Month, Year, SubGrupoUnidadeId, GrupoUnidadeId }) => {
    return AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/reports/summary/occurrences',
      params: {
        Month,
        Year,
        SubGrupoUnidadeId,
        GrupoUnidadeId,
      },
      headers: {
        'content-type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
        EmpresaId: empresa,
        UnidadeId: unidade !== undefined ? unidade : '',
      },
    });
  },
};

export { HomeService };
